type SocketEnvelope = Record<string, unknown>

const isRecord = (value: unknown): value is SocketEnvelope =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

const readEventName = (value: SocketEnvelope): string | null => {
  const eventName = value.action || value.event || value.type
  return typeof eventName === 'string' && eventName.trim() ? eventName : null
}

export function parseSocketEvent(raw: string): { eventName: string | null; data: unknown } {
  const parsed = JSON.parse(raw)
  if (!isRecord(parsed)) return { eventName: null, data: undefined }

  const topLevelEvent = readEventName(parsed)
  const nestedEnvelope = isRecord(parsed.data) ? parsed.data : null
  const nestedEvent = nestedEnvelope ? readEventName(nestedEnvelope) : null
  const eventName = topLevelEvent === 'sendMessage' && nestedEvent ? nestedEvent : topLevelEvent || nestedEvent
  const payloadEnvelope = topLevelEvent === 'sendMessage' && nestedEvent && nestedEnvelope ? nestedEnvelope : parsed

  if (!Object.prototype.hasOwnProperty.call(payloadEnvelope, 'data')) {
    return { eventName, data: undefined }
  }

  const payload = payloadEnvelope.data
  if (
    isRecord(payload) &&
    Object.prototype.hasOwnProperty.call(payload, 'data') &&
    (readEventName(payload) || Object.prototype.hasOwnProperty.call(payload, 'channel'))
  ) {
    return { eventName, data: payload.data }
  }

  if (
    isRecord(payload) &&
    Object.prototype.hasOwnProperty.call(payload, 'data') &&
    isRecord(payload.data) &&
    typeof payload.data.id === 'number' &&
    typeof payload.data.subject === 'string'
  ) {
    return { eventName, data: payload.data }
  }

  return { eventName, data: payload }
}
